/**
 *
 * @param filters
 * @param filterType
 * @param filterOption
 * @returns Sets the filterOption to the right attribute of the
 * filterOption object using the filterType.
 */
export function setFilters(filters, filterType, filterOption) {
    // add filter type
    if (filterType === "provider") {
        filters.providerNameFilter = filterOption;
    } else if (filterType === "country") {
        filters.countryFilter = filterOption;
    } else if (filterType === "verifiable_elements") {
        filters.verifiableElementsFilter = filterOption;
    } else if (filterType === "status") {
        filters.statusFilter = filterOption;
    } else if (filterType === "sub_dp") {
        filters.subDPTypeFilter = filterOption;
    } else if (filterType === "invoice_name") {
        filters.invoiceNameFilter = filterOption;
    }
    return filters;
}


export function setTestcacheFilters(filters, filterType, filterOption) {
    // add filter type
    if (filterType === "country") {
        filters.testcacheCountryFilter = filterOption;
    } else if (filterType === "source_type") {
        filters.testcacheDataSourceTypeFilter = filterOption;
    }
    return filters;
}

/**
 * @param filters
 * @param filterType
 * @param filterOption
 * @returns Sets the filterOption to the right attribute of the
 * KYB testcache filterOption object using the filterType.
 */
export function setKYBTestcacheFilters(filters, filterType, filterOption) {
    if (filterType === "country") {
        filters.kybTestcacheCountryFilter = filterOption;
    } else if (filterType === "datasource") {
        filters.kybTestcacheDataSourceFilter = filterOption;
    }
    return filters;
}

